
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

import { Title } from '@/interfaces/titles';

import BuyBoxREST from '@/components/buybox/REST/BuyBoxREST.vue';

import TrailerModal from '@/components/details/TrailerModal.vue';
import PosterREST from '@/components/poster/REST/PosterREST.vue';
import { ModalHelper } from '@/helpers/modal-helper';
import { getViewport } from '@/helpers/ui-helper';
import BasicButton from '@/ui-components/BasicButton.vue';
import { namespace } from 'vuex-class';

const User = namespace('user');

@Component({
	name: 'RecommenderTitleCard',
	components: { PosterREST, BasicButton, BuyBoxREST },
})
export default class RecommenderTitleCard extends Vue {
	@Prop(Object) title: Title;
	@Prop({ type: Number, default: 0 }) matchingScore: number;
	isDescriptionExpanded = false;

	@User.Getter isLoggedIn: (providerName?: string) => boolean;

	get viewport() {
		return getViewport();
	}

	get badgeColor() {
		if (this.matchingScore >= 0 && this.matchingScore < 50) {
			return '#A30000';
		} else if (this.matchingScore >= 50 && this.matchingScore < 60) {
			return '#DD7E00';
		} else if (this.matchingScore >= 60) {
			return '#339B2A';
		}
	}

	get shouldShowQuickActions() {
		return process.client && this.isLoggedIn();
	}

	openTrailer(title: Title) {
		ModalHelper.openModal(TrailerModal, { title, clip: title.clips[0], source: 'recommender-title-card' });
	}
}
